import React from 'react';
import './styleChatConversation.scss';

export const ChatConversation = () => {
    return (

        <div className='container-modal-messages-chat-emergent'>


            <div className='subcontainer-modal-messages-chat-emergent'>

                <div className='header-container-modal-chat-emergent'>
                    <img className='header-user-modal-chat-emergent' />
                    <p className=''></p>
                    <img />



                </div>

            </div>
        </div>
    )
}
